var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 34,
    viewBox: "0 0 30 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 11.3333C19.5 14.2474 17.4283 16.5 15 16.5C12.5717 16.5 10.5 14.2474 10.5 11.3333C10.5 8.41917 12.5717 6.16663 15 6.16663C17.4283 6.16663 19.5 8.41917 19.5 11.3333Z",
    fill: "#1B1B1B",
    stroke: "#1B1B1B",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.37963 22.8696C7.1673 20.3924 9.67086 19.125 12.2702 19.125H17.7298C20.3291 19.125 22.8327 20.3924 23.6204 22.8696C23.9632 23.9478 24.2467 25.218 24.3413 26.6251C24.3783 27.1761 23.9273 27.625 23.375 27.625H6.625C6.07272 27.625 5.62166 27.1761 5.65869 26.6251C5.75327 25.218 6.0368 23.9478 6.37963 22.8696Z",
    fill: "#1B1B1B",
    stroke: "#1B1B1B",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileActive);
export default __webpack_public_path__ + "static/media/profile-active.3e00e786693c145c297164b68e7e4441.svg";
export { ForwardRef as ReactComponent };